import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import CourseForm from './CourseForm';
import { updateCourse } from '../../services/courseService';
import { getUnitIDList } from '../../utilities/unitFormat';
import {
  getFormattedCategories,
  formatCategoriesArray
} from '../../utilities/courseFormat';

function CourseEdit(props) {
  const course = props.course;

  const initialValues = {
    code: course?.code,
    title: course?.title,
    description: course?.description,
    category: course?.category,
    isActive: course?.isActive,
    isPublic: course?.isPublic,
    isOffline: course?.isOffline,
    studentCount: course?.studentCount,
    instructorCount: course?.instructorCount,
    units: getUnitIDList(course?.units),
    benefits: course?.benefits,
    price: course?.price,
    currency: course?.currency,
    duration: course?.duration,
    classTime: course?.classTime,
    videoTime: course?.videoTime,
    mode: course?.mode,
    type: course?.type,
    by: course?.by,
    domainAccess:
      course?.domainAccess?.map((da) => {
        return da;
      }) ?? [],
    categories: course?.categories
      ? getFormattedCategories(course?.categories)
      : null,
    university: course?.university,
    meetCreatorRecordingLink: course?.meetCreatorRecordingLink,
    imgData: course?.imgData,
    link: course?.link,
    discoveryCardImgData: course?.discoveryCardImgData,
    discoveryDescription: course?.discoveryDescription,
    avatarImgData: course?.avatarImgData,
    searchImgData: course?.searchImgData,
    tags: course?.tags,
    thumbnailImgData: course?.thumbnailImgData,
    learnPortalNavbarImgData: course?.learnPortalNavbarImgData,
    customCardMetadata: course?.customCardMetadata,
    areCommentsAllowed: course?.areCommentsAllowed,
    areAllUnitsUnlocked: course?.areAllUnitsUnlocked,
    customTag: course?.customTag,
    trailer: course?.trailer,
    firstSuggestedCourse: course?.firstSuggestedCourse,
    secondSuggestedCourse: course?.secondSuggestedCourse
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values
    };
    if (payload.categories)
      payload.categories = formatCategoriesArray(payload.categories);

    await updateCourse(course.courseId, payload)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data updated successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Edit Course ${course.code}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CourseForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          currentUnits={course?.units}
        />
      )}
    </Modal>
  );
}

export default CourseEdit;
